var map = {
	"./context-consumer.entry.js": [
		8028,
		28
	],
	"./continuum-quiz_2.entry.js": [
		3421,
		421
	],
	"./stencil-async-content.entry.js": [
		5615,
		615
	],
	"./stencil-route-link.entry.js": [
		5710,
		710
	],
	"./stencil-route-switch.entry.js": [
		644,
		644
	],
	"./stencil-route-title.entry.js": [
		3490,
		490
	],
	"./stencil-route.entry.js": [
		9306,
		306
	],
	"./stencil-router-prompt.entry.js": [
		5949,
		949
	],
	"./stencil-router-redirect.entry.js": [
		2968,
		968
	],
	"./stencil-router.entry.js": [
		7569,
		569
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5976;
module.exports = webpackAsyncContext;